<template>
    <div class="body_contain">
        <el-row>
            <el-col :span="24">
                <div class="chart_title">
                    <span>全国工商管理人才需求动态展示平台</span>
                    <div class="time">{{data.starttime + " 至 " + data.endtime}}</div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="14">
                <div>
                    <el-row>
                        <el-col :span="24">
                            <div class="business_title">
                                <span><i class="el-icon-d-arrow-right"></i> 工商管理各类别人才需求量</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="1">
                        <el-col :span="4.8" v-for="(o, index) in data.sorts">
                            <div class="business_card">
                                <span class="business_name">{{o.name}}</span>
                                <div class="business_bottom">
                                    <div>
                                        <i class="el-icon-school"></i>
                                    </div>
                                    <div>
                                        <div>人才需求量</div>
                                        <div>{{o.value}} <span>人</span></div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="10">
                <div id="china_map" class="map"></div>
            </el-col>
        </el-row>
        <el-row>
            <el-row :gutter="2">
                <el-col :span="6">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 按学历统计</span>
                        </div>
                        <div id="chartOne" class="c_chart"></div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 能力关键词</span>
                        </div>
                        <div id="chartTwo" class="c_chart">
                            <wordcloud
                                    :data="wordData"
                                    nameKey="name"
                                    valueKey="value"
                                    :margin="{top:0,bottom:0,left:0,right:0}"
                                    :fontSize="[20, 50]"
                                    :color="wordColors"
                                    :showTooltip="false">
                            </wordcloud>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 近6个月岗位群薪资水平</span>
                        </div>
                        <div id="chartThree" class="c_chart"></div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 热门岗位TOP10</span>
                        </div>
                        <div id="chartFour" class="c_chart" style="overflow:auto">
                            <el-carousel height="360px" direction="vertical" :autoplay="true">
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index < 3">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 2 && index < 6">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 5 && index < 9">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 8">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-row>
    </div>
</template>

<script>
    import echarts from "echarts";
    import 'echarts/map/js/china.js';
    import data from './data/mba';
    import wordcloud from 'vue-wordcloud';

    export default {
        name: "mba",
        components: {
            wordcloud,
        },
        data() {
            return {
                data:data,
                wordColors: [],
                wordData: [],
                count: 10,
                loading: false,
                sortType:[
                    {
                        name: '工商企业管理',
                        children: [
                            {name: '高级管理'},
                            {name: '生产/营运'},
                            {name: '信息管理'},
                            {name: '质量管理'},
                            {name: '采购管理'},
                            {name: '管理咨询'},
                            {name: '人力资源'},
                            {name: '行政'},
                        ]
                    },
                    {
                        name: '商务管理',
                        children: [
                            {name: '商务管理'}
                        ]
                    },
                    {
                        name: '连锁经营',
                        children: [
                            {name: '连锁经营'}
                        ]
                    },
                ],
                chartThreeTime:['', '', '', '', '', ''],
                // chartThreeTime:['1月', '2月', '3月', '4月', '5月', '6月'],
            };
        },
        computed: {
            noMore () {
                return this.count >= 20
            },
            disabled () {
                return this.loading || this.noMore
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initEchartMap();
                this.initEchartOne();
                this.initEchartTwo();
                this.initEchartThree();
            });
        },
        methods: {
            load () {
                this.loading = true;
                setTimeout(() => {
                    this.count += 2;
                    this.loading = false
                }, 2000)
            },
            //初始化中国地图
            initEchartMap() {
                let optionMap = {
                    layoutCenter: ['40%', '50%'],
                    layoutSize: "100%",
                    tooltip: {
                        triggerOn: "mousemove",   //mousemove、click
                        padding: 4,
                        borderWidth: 1,
                        borderColor: '#333333',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 13
                        },
                    },
                    visualMap: {
                        min: 0, // 最小值
                        max: 100000, // 最大值
                        text: ['100000', '0'],
                        left:'right',
                        realtime: false,
                        calculable: false,
                        inRange: {
                            color: ['#FDD692','#EC7357','#c03546'] // 渐变颜色
                        },
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 10
                        },
                    },
                    geo: {
                        map: "china",
                        // scaleLimit: {
                        //     min: 1,
                        //     max: 2
                        // },
                        zoom: 1.3,
                        top: 120,
                        label: {
                            normal: {
                                show: true,
                                fontSize: "10",
                                textStyle:{
                                    color: "#333333"
                                }
                            },
                            emphasis: {
                                show: true,
                                fontSize: "10",
                                textStyle:{
                                    color: "#ffffff"
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor:"#FFEEE4",
                                borderColor: "rgba(255,255,255,0.9)",
                            },
                            emphasis: {
                                areaColor: "#EC7357",
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                borderWidth: 0
                            }
                        }
                    },
                    series: [
                        {
                            name: "人才需求分布",
                            type: "map",
                            geoIndex: 0,
                            data: data.provinces
                        }
                    ]
                };
                let mapDiv = document.getElementById('china_map');
                let myChart = echarts.init(mapDiv);
                myChart.setOption(optionMap);
            },
            initEchartOne() {
                let c_data = this.sortType;
                c_data.forEach((v,i)=>{
                    v.children.forEach((vv,ii)=>{
                        this.$set(vv,'children',[]);
                        this.data.edus.forEach((item,index)=>{
                            if(vv.name == item.jobsort){
                                vv.children.push({name:item.edu,value:item.value});
                            }
                        })

                    });
                });
                let option = {
                    tooltip: {
                        triggerOn: "mousemove",   //mousemove、click
                        padding: 4,
                        borderWidth: 1,
                        borderColor: '#333333',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 13
                        },
                    },
                    color: ['#f9a11b','#EC7357','#c03546'],
                    series: {
                        type: 'sunburst',
                        radius: [0, '95%'],
                        itemStyle: {
                            borderWidth: 1,
                            borderColor:'#333',
                        },
                        data:c_data,
                        levels: [{}, {
                            r0: '0%',
                            r: '40%',
                            label: {
                                rotate: 0,
                                color:'#ffffff',
                                fontSize:14
                            }
                        }, {
                            r0: '40%',
                            r: '74%',
                            itemStyle: {
                                opacity: 0.7,
                            },
                            label: {
                                align: 'right',
                                color:'#ffffff',
                                fontSize:11
                            }
                        },{
                            r0: '74%',
                            r: '76%',
                            label: {
                                formatter:'{b}:{c}',
                                position: 'outside',
                                padding: 3,
                                silent: false,
                                color:'#ffffff',
                                fontSize:11
                            },
                        }]
                    }
                };

                let chart = document.getElementById('chartOne');
                let myChart = echarts.init(chart);
                myChart.setOption(option);
            },
            initEchartTwo() {
                this.wordColors = ['#c03546','#f94e3f','#EC7357','#FDD692','#FFEEE4'];
                this.wordData = [
                    {
                        "name": "工作",
                        "value": 9006
                    },
                    {
                        "name": "商品",
                        "value": 4322
                    },
                    {
                        "name": "会员",
                        "value": 4224
                    },
                    {
                        "name": "管理",
                        "value": 2778
                    },
                    {
                        "name": "服务",
                        "value": 2269
                    },
                    {
                        "name": "销售",
                        "value": 2208
                    },
                    {
                        "name": "沟通",
                        "value": 1904
                    },
                    {
                        "name": "公司",
                        "value": 1819
                    },
                    {
                        "name": "分享",
                        "value": 1783
                    },
                    {
                        "name": "采购",
                        "value": 1630
                    },
                    {
                        "name": "团队",
                        "value": 1590
                    },
                    {
                        "name": "类别",
                        "value": 1277
                    },
                    {
                        "name": "经验",
                        "value": 1076
                    },
                    {
                        "name": "微信",
                        "value": 986
                    }
                ];
            },
            initEchartThree(){
                let sort_type = new Array();
                this.sortType.forEach((v,i)=>{
                    v.children.forEach((vv,ii)=>{
                        let s = vv.name;
                        sort_type.push(s);
                    });
                });
                let sort_value = new Array();
                for (let x = 0; x < sort_type.length; x++) {
                    sort_value[x] = new Array();
                    for (let y = 0; y < 6; y++) {
                        sort_value[x][y] = 0;
                    }
                }


                let pos = 6;
                let lastName = '';
                data.pays.forEach((v,i)=>{
                    sort_type.forEach((vv,ii)=>{
                        if (v.name != lastName) {
                            lastName = v.name;
                            pos = parseInt(pos) - 1;
                        }
                        if(v.jobsort == vv){
                            let n = parseInt(v.name) - 1;
                            sort_value[ii][pos] = v.value;
                            this.chartThreeTime[pos] = parseInt(v.name) + '月';
                        }
                    });
                });
                let c_data = new Array();
                sort_type.forEach((v,i)=>{
                    let s = {
                        name: sort_type[i],
                        type: 'bar',
                        stack: 'total',
                        label: {
                            show: false
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: sort_value[i]
                    };
                    c_data.push(s);
                });
                let option = {
                    // color:['#f9a11b','#EC7357','#c03546'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // Use axis to trigger tooltip
                            type: 'shadow'        // 'shadow' as default; can also be 'line' or 'shadow'
                        }
                    },
                    legend: {
                        data: sort_type,
                        top:'2%',
                        textStyle:{
                            color:'#ffffff',
                            fontSize:11,
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '5%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        axisLabel:{
                            textStyle:{
                                color:'#ffffff',
                            }
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: this.chartThreeTime,
                        axisLabel:{
                            textStyle:{
                                color:'#ffffff',
                            }
                        }
                    },
                    series: c_data
                };
                let chart = document.getElementById('chartThree');
                let myChart = echarts.init(chart);
                myChart.setOption(option);

            },
        }
    };
</script>
<style scoped>
    .body_contain {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        background-color: #333333;
    }

    .chart_title {
        width: 100%;
        height: 100px;
        margin: 0 0 10px 0;
        text-align: center;
        background-color: #000000;
        border-bottom:3px solid #D09E88;
    }

    .time{
        font-size: 12px;
        color: #EAEAEA;
        position: absolute;
        z-index: 99;
        right:8px;
        bottom:24px;
    }

    .chart_title span {
        font-size: 30px;
        color: #ffffff;
        line-height: 100px;
        font-family: ".PingFang SC";
    }

    .map {
        width: 100%;
        height: 360px;
    }

    .business_title {
        width: 100%;
        height: 60px;
        text-align: left;
    }

    .business_title span {
        font-size: 20px;
        color: #ffffff;
        line-height: 60px;
        src: url('/data/PingFang Regular.ttf');
        font-family: "PingFang Regular";
        padding-left: 10px;
    }

    .business_card {
        width: 100%;
        height: 150px;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .business_name {
        font-size: 16px;
        line-height: 50px;
        color: #ffffff;
        text-align: center;
        padding-left: 10px;
    }

    .business_bottom {
        width: 96%;
        margin: auto auto;
        background-color: #333333;
        height: 90px;
    }

    .business_bottom > div {
        width: 60%;
        float: left;
        padding: 0;
        margin: 0;
    }

    .business_bottom > div:first-child {
        width: 40%;
    }

    .business_bottom div i {
        font-size: 68px;
        color: rgba(255, 255, 255, 0.3);
        padding: 0 14px;
        position: relative;
        top: 15px;
    }

    .business_bottom div div {
        font-size: 15px;
        text-align: right;
        color: #ffffff;
        line-height: 40px;
        padding: 0 6px;
    }

    .business_bottom div div span {
        font-size: 8px;
        text-align: right;
        color: #ffffff;
        line-height: 30px;
    }

    .business_bottom div div:first-child {
        font-size: 14px;
        font-weight: bold;
        color: #F7AA97;
        line-height: 50px;
    }

    .c_part {
        width: 100%;
        height: 400px;
        background-color: #534847;
        border-right: 1px solid rgba(255, 255, 255, 0.28);
    }
    .c_title {
        width:100%;
        height:40px;
        background-color: rgba(0, 0, 0, 0.7);
    }
    .c_title span{
        font-size: 18px;
        color: #ffffff;
        line-height: 40px;
        font-family: ".PingFang SC";
        padding-left: 10px;
    }

    .c_chart {
        width: 100%;
        height: 360px;
    }

    .business2_card {
        width: 100%;
        height: 120px;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .business2_name {
        font-size: 16px;
        line-height: 40px;
        color: #ffffff;
        text-align: center;
        padding-left: 20px;
    }

    .business2_bottom {
        width: 90%;
        margin: auto auto;
        background-color: #534847;
        height: 70px;
    }

    .business2_bottom > div {
        width: 50%;
        float: left;
        padding: 0;
        margin: 0;
    }

    .business2_bottom div i {
        font-size: 60px;
        color: rgba(255, 255, 255, 0.3);
        padding-left: 10px;
        position: relative;
        top: 10px;
    }

    .business2_bottom div div {
        font-size: 15px;
        text-align: right;
        color: #ffffff;
        line-height: 35px;
        padding: 0 6px;
    }

    .business2_bottom div div span {
        font-size: 8px;
        text-align: right;
        color: #ffffff;
        line-height: 30px;
    }

    .business2_bottom div div:first-child {
        font-size: 16px;
        font-weight: bold;
        color: #F7AA97;
        line-height: 40px;
    }
</style>
